import { chordFor, hits, type Style } from '../style';

/** Azonto: bouncy, syncopated kick, shaker running, a cheeky synth hook. */
const CHORDS = [[62, 65, 69], [58, 62, 65], [60, 64, 67], [57, 60, 64]]; // Dm Bb C Am
const HOOK = [74, 0, 72, 0, 69, 0, 72, 74, 0, 0, 77, 0, 74, 0, 72, 0];

export const AZONTO: Style = {
  bpm: 120,
  swing: 0.08,
  play(kit, step, bar, t, len, energy) {
    const chord = chordFor(CHORDS, bar);
    if (hits('x.....x.x.....x.', step)) kit.kick(t);
    if (hits('....x.......x...', step)) kit.clap(t);
    kit.shaker(t, 0.8);
    if (hits('...x...x...x...x', step)) kit.bell(t, true);
    if (hits('x..x..x...x..x..', step)) kit.bass(t, (chord[0] ?? 62) - 24, len * 2);
    const note = HOOK[step] ?? 0;
    if (note && (bar % 2 === 1 || energy > 0.5)) kit.lead(t, note, len * 1.5);
  },
};
